import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';

const SessionsTab = ({ className, selected, children, ...props }) => {
  const cn = useClassNames(
    () => [
      'mr-8',
      'lg:mr-12',
      'focus:outline-none',
      'font-semibold',
      selected ? ['border-b-4', 'border-blue-500'] : 'text-slate-400',
      className,
    ],
    [className, selected],
  );
  return (
    <button type="button" className={cn} {...props}>
      {children}
    </button>
  );
};

SessionsTab.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  selected: PropTypes.bool,
  children: PropTypes.node,
};

SessionsTab.defaultProps = {
  selected: false,
};

export default SessionsTab;
